export default defineAppConfig({
  ui: {
    primary: 'bibeltv',
    gray: 'cool', // 'zinc' tailwind color
    button: {
      base: 'disabled:opacity-40',
    },
  },
})
